import {
  SET_APP_LOADING,
  SET_APP_LOADING_SAMPLES
} from '../constants/actionTypes';

export const setAppLoading = payload => {
  return {
    type: SET_APP_LOADING,
    payload
  };
};

export const setAppLoadingSamples = payload => {
  return {
    type: SET_APP_LOADING_SAMPLES,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/loading.js